import { createMemo } from "solid-js"
import createEntityGridXY from "../../lib/core/tile_position_xy/createEntityGridXY"
import createSharedCachedFactory from "./createSharedCachedFactory"
import useGridWidthHeight from "./useGridWidthHeight"

export const useEntityGridXYMemo = createSharedCachedFactory((engine) => {
  const getGridSize = useGridWidthHeight(engine)

  const getEntityGridXY = createMemo(() => {
    const { width, height } = getGridSize()
    return createEntityGridXY(engine.state.ents, width, height)
  })

  return getEntityGridXY
})